module.exports = __webpack_public_path__ + "media/images/icons/directions-28fe4a3116db49fbcde4c219d7687952.png";